var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tap',{staticClass:"close-outer"},[_c('button',{class:{
    'close-button': true,
    'is-icon': true,
    'button': true,
    'is-primary': !_vm.inverted,
    'is-primary-inverted': _vm.inverted,
    'is-small': true
  },attrs:{"type":"button"}},[_c('span',{staticClass:"icon"},[_c('span',{class:("icon-chevron-" + _vm.direction)})])])])}
var staticRenderFns = []

export { render, staticRenderFns }